import { VideoCategoryOutputModel } from "./category.model";

export enum VideoFlag {
  HOMEPAGE = "homepage",
  RESOURCE = "resource"
}

export enum VideoStatus {
  PUBLISH = "publish",
  UNPUBLISH = "unpublish"
}

export type VideoInputModel = {
  id?: string;
  languageId: string;
  title: string;
  description: string;
  status: VideoStatus;
  categoryId?: string;
  video?: string;
  linkVideo?: string;
  flag: VideoFlag;
};

export type VideoCategoryApiOutputModel = {
  id: string;
  videoId: string;
  categoryId: string;
  category: VideoCategoryOutputModel;
}

export type VideoOutputModel = {
  id: string;
  title: string;
  flag: VideoFlag;
  languageId: string;
  code: string;
  description: string | null;
  videoCategory: VideoCategoryApiOutputModel[];
  video: string | null;
  linkVideo: string;
  status: VideoStatus;
  views: number;
}